import { Component, LOCALE_ID, Inject, Output, EventEmitter } from '@angular/core';
import {CookieOptionsArgs, CookieService} from "angular2-cookie/core";
import { GlobalsService } from '../app/common/services/globals.service';
import { SharedService } from '../app/common/services/shared.service';
import { ActivatedRoute, NavigationCancel } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import { SAML } from './common/SAML';
import { cookie } from './common/cookie';
import { sbe_cookie } from './common/sbe_cookie';
import { Router } from '@angular/router';
import { StringifyOptions } from 'querystring';
import { SBE_SAML } from './common/SBE_SAML';
import { first } from "rxjs/operators";
import { Subscription, interval } from 'rxjs';

declare var $: any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'paynow';

  saml: SAML;
  sbe_saml: SBE_SAML;
  partnerParam = '';
  languageParam = '';
  cookieValue = '';
  decodedCookieValue = '';
  decodedCookieObj: cookie;
  sbe_decodedCookieObj: sbe_cookie;
  modalMsg = '';
  simulationParam: boolean;
  application = '';
  existing_session_cookie_obj: existing_session_cookie_object;
  sbe_call_saml = true;
  ffmPartnerWYND: boolean = false;

  app_Partner = {isFFM: false, partner: ''}

  @Output() SBERecentPayment = new EventEmitter<any>();

  cancel() {
    // Maintain FFM status and partner logo details if user clicks on exit from FFM portal
    if(location.href.includes("ffm")) {

      const partner = location.href.indexOf("=")!== -1? 
      location.href.slice(location.href.indexOf("=")+1, location.href.indexOf("&")):'highmark';

      localStorage.setItem('isFFM', JSON.stringify(true))
      localStorage.setItem('partner', partner)
    }
    $('#SBERecentPaymentModal').modal('hide');
    $('#SBERecentPaymentModalIBC').modal('hide');
    this.router.navigate(['/done']);
  }

  makeNewPayment() {
    $('#SBERecentPaymentModal').modal('hide');
    $('#SBERecentPaymentModalIBC').modal('hide');
  }

  get LastPaymentDate() {
    return GlobalsService.SBE_LastPaymentDate;
  }

  get LastPaymentAmount() {
    return GlobalsService.SBE_LastPaymentAmount;
  }

  get LastProposedCoverageEffectDate() {
    return GlobalsService.SBE_LastProposedCoverageEffectDate;
  }

  get returnToGWCModalMsg() {
    return this.modalMsg;
  }

  get partner() {
    return GlobalsService.partner;
  }

  // send back the user to GWC
  returnToShopping() {
    history.go(-1);
  }

  get returnURL() {
    return this.saml.ReturnURL.split(':')[1];
  }

  getCookie(key: string) {
    return this.cookieService.get(key);
  }

  wait(ms) {
    var start = new Date().getTime();
    var end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }

  constructor(
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private translate: TranslateService,
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private gservice: GlobalsService
  ) {

    //this.cookieService.put( 'ibc_gwc_ebill_fed_cookie', 'ewogICAgIkxhbmd1YWdlIjoiRU4iLAogICAgIkFwcGxpY2F0aW9uSUQiOiJJQkEtODM4MzMzOTIzOSIsCiAgICAiQ29uc3VtZXJSZWZlcmVuY2VJRCI6IjEwNTgyMjk5IiwKICAgICJNYXJrZXRJbmRpY2F0b3IiOiJJTkRJVklEVUFMIiwKICAgICJTYWxlc0NoYW5uZWwiOiJTYWxlc0Nvbm5lY3QiLAogICAgIlByb3Bvc2VkQ292ZXJhZ2VFZmZlY3RpdmVEYXRlIjoiMDYvMDEvMjAyMCIsCiAgICAiQXNzaWduZWRRSFBJZGVudGlmaWVyIjoiMzEyNzRXVjA0OTAwMDEtMDEiLAogICAgIkZpcnN0TmFtZSI6InB1aiIsCiAgICAiTWlkZGxlTmFtZSI6IiIsCiAgICAiTGFzdE5hbWUiOiJyYXkiLAogICAgIlN1ZmZpeE5hbWUiOiIiLAogICAgIlN0cmVldE5hbWUxIjoiMTIzIHRlc3Qgc3QiLAogICAgIlN0cmVldE5hbWUyIjoiIiwKICAgICJTdGF0ZSI6IlBBIiwKICAgICJDaXR5TmFtZSI6InBlbm5zeWx2YW5pYSIsCiAgICAiWmlwQ29kZSI6IjE4MDM5IiwKICAgICJDb250YWN0RW1haWxBZGRyZXNzIjoicHVqaXRoYS5yYXlhQGd1aWRld2VsbGNvbm5lY3QuY29tIiwKICAgICJBZGRpdGlvbmFsSW5mb3JtYXRpb24iOiJwdWosIHJheSIsCiAgICAiUHJvZHVjdGxpbmVuYW1lIjoiSGVhbHRoIiwKICAgICJwcm9kdWN0bGluZWNvZGUiOiI4IiwKICAgICJQbGFuSUQiOiIyMjcyMjE4NzY5OTciLAogICAgIkFnZW50SUQiOiJaMTEzLVoxMTMiLAogICAgIlNlZ21lbnQiOiJVNjUiLAogICAgIlVzZXJUeXBlIjoiQWdlbnQiLAogICAgIlRlbmFudElEIjoiR1dDSUJDUEEiLAogICAgIlBsYW5OYW1lIjoiS2V5c3RvbmUgSE1PIFNpbHZlciIsCiAgICAiU3VwcHJlc3NDcmVkaXRDYXJkIjoiTiIsCiAgICAiUHJlbWl1bUFtb3VudFRvdGFsIjoiNTI3LjMzIiwKICAgICJUb3RhbEFtb3VudE93ZWQiOiI1MjcuMzMiLAogICAgIkF1dGhUb2tlbiI6IlRlc3QiLAogICAgIlJldHVyblVSTCI6Imh0dHBzOi8vYWdlbnQtdGVsZXNhbGVzLndlYnNhbGVzLnFhLmlieC5jb20vaXNzL3NlcnZpY2UvcGF5bWVudHMvcG9zdFJlc3BvbnNlIiwKICAgICJQYXltZW50VHJhbnNhY3Rpb25JRCI6IiIsCiAgICAiVW5pcXVlQmluZGVyQ29kZSI6IiIKfQ==' ); // To Set Cookie
    //console.log('simulator_cookie_status', this.getCookie('simulator_cookie_status'));
    if (this.getCookie('simulator_cookie_status') === 'true') {
      this.simulationParam = true;
      console.log("Using simulation");
      //console.log(atob(this.getCookie('simulator_cookie')));
      if (atob(this.getCookie('simulator_cookie')).includes('ApplicationID') && !atob(this.getCookie('simulator_cookie')).includes('W3LL'))  {
        if (atob(this.getCookie('simulator_cookie')).includes('IBC')) {
          this.assignPartner('IBC');
          this.cookieService.put('ibc_gwc_ebill_fed_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('ibc_gwc_ebill_fed_cookie');
          this.cookieService.remove('ibc_gwc_ebill_fed_cookie');
        } else if (atob(this.getCookie('simulator_cookie')).includes('AHNJ')) {
          this.assignPartner('AHNJ');
          this.cookieService.put('ahnj_gwc_ebill_fed_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('ahnj_gwc_ebill_fed_cookie');
          this.cookieService.remove('ahnj_gwc_ebill_fed_cookie');
        }
      } else if(atob(this.getCookie('simulator_cookie')).includes('Payload')) { // checking for FFM if the simulation cookie has payload
          this.application = 'FFM';
          this.assignPartner('HHP');
          this.cookieService.put('ffm_ebill_fed_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('ffm_ebill_fed_cookie');
          this.cookieService.remove('ffm_ebill_fed_cookie');
          router.navigate(['/ffm']);
      } else if(atob(this.getCookie('simulator_cookie')).includes('SpLoad')) { // checking for Salesportal if the simulation cookie has payload
        this.application = 'SP';
        this.assignPartner('HHP');
        this.cookieService.put('hhp_sp_ebill_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
        this.cookieValue = this.getCookie('hhp_sp_ebill_cookie');
        this.cookieService.remove('hhp_sp_ebill_cookie');
        router.navigate(['/SP']);
      }else if(atob(this.getCookie('simulator_cookie')).includes('HspLoad')) { // checking for Health Sherpa if the simulation cookie has payload
        this.application = 'HS';

        this.assignPartner('HHP');
        this.cookieService.put('hhp_hs_ebill_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
        this.cookieValue = this.getCookie('hhp_hs_ebill_cookie');
        this.cookieService.remove('hhp_hs_ebill_cookie');
        router.navigate(['/HealthSherpa']);
      } else if(atob(this.getCookie('simulator_cookie')).includes('W3LL')) { 
        if(atob(this.getCookie('simulator_cookie')).includes('AHNJ') ) {
          this.application = 'W3LL';
          this.assignPartner('AHNJ');
          this.cookieService.put('w3ll_ebill_ahnj_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('w3ll_ebill_ahnj_cookie');
          this.cookieService.remove('w3ll_ebill_ahnj_cookie');
          router.navigate(['/w3ll']);
        } else {
          this.application = 'W3LL';
          this.assignPartner('IBC');
          this.cookieService.put('w3ll_ebill_ibc_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('w3ll_ebill_ibc_cookie');
          this.cookieService.remove('w3ll_ebill_ibc_cookie');
          router.navigate(['/w3ll']);
        }
      } else {
        this.application = 'SBE';
        if (atob(this.getCookie('simulator_cookie')).includes('HHP')) {
          this.assignPartner('HHP');
          this.cookieService.put('hhp_sbe_ebill_fed_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('hhp_sbe_ebill_fed_cookie');
          this.cookieService.remove('hhp_sbe_ebill_fed_cookie');
          router.navigate(['/sbe']);
        } else if (atob(this.getCookie('simulator_cookie')).includes('IBC')) {
          this.assignPartner('IBC');
          this.cookieService.put('ibc_sbe_ebill_fed_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('ibc_sbe_ebill_fed_cookie');
          this.cookieService.remove('ibc_sbe_ebill_fed_cookie');
          router.navigate(['/sbe']);
        } else if (atob(this.getCookie('simulator_cookie')).includes('AHNJ')) {
          this.assignPartner('AHNJ');
          this.cookieService.put('ahnj_sbe_ebill_fed_cookie', this.getCookie('simulator_cookie')); // To Set Cookie
          this.cookieValue = this.getCookie('ahnj_sbe_ebill_fed_cookie');
          this.cookieService.remove('ahnj_sbe_ebill_fed_cookie');
          router.navigate(['/sbe']);
        }
      }
      this.cookieService.remove('simulator_cookie');
      this.cookieService.remove('simulator_cookie_status');
    } else {
      var i;
      for (i = 0; i < 5; i++) {

        //console.log(this.cookieService.getAll());

        if (this.getCookie('ibc_gwc_ebill_fed_cookie') != null) {
          this.assignPartner('IBC');
          this.cookieValue = this.getCookie('ibc_gwc_ebill_fed_cookie');
          this.cookieService.put('ibc_gwc_ebill_fed_cookie','null' ,{domain:'.ibx.com'});
          break;
        } else if (this.getCookie('ahnj_gwc_ebill_fed_cookie') != null) {
          this.assignPartner('AHNJ');
          this.cookieValue = this.getCookie('ahnj_gwc_ebill_fed_cookie');
          this.cookieService.put('ahnj_gwc_ebill_fed_cookie','null' ,{domain:'.amerihealth.com'});
          break;
        } else if (this.getCookie('ibc_sbe_ebill_fed_cookie') != null) {
          this.application = 'SBE';
          this.assignPartner('IBC');
          this.cookieValue = this.getCookie('ibc_sbe_ebill_fed_cookie');
          this.cookieService.put('ibc_sbe_ebill_fed_cookie','null' ,{domain:'.ibx.com'});
          router.navigate(['/sbe']);
          break;
        } else if (this.getCookie('ahnj_sbe_ebill_fed_cookie') != null) {
          this.application = 'SBE';
          this.assignPartner('AHNJ');
          this.cookieValue = this.getCookie('ahnj_sbe_ebill_fed_cookie');
          this.cookieService.put('ahnj_sbe_ebill_fed_cookie','null' ,{domain:'.amerihealth.com'});
          router.navigate(['/sbe']);
          break;
        } else if (this.getCookie('hhp_sbe_ebill_fed_cookie') != null) {
          this.application = 'SBE';
          this.assignPartner('HHP');
          this.cookieValue = this.getCookie('hhp_sbe_ebill_fed_cookie');
          this.cookieService.put('hhp_sbe_ebill_fed_cookie','null' ,{domain:'.highmark.com'});
          router.navigate(['/sbe']);
          break;
        } else if(this.getCookie('ffm_ebill_fed_cookie') != null) { // checking ffm_ebill_fed_cookie cookie and assign in cookevalue
          this.application = 'FFM';
          this.assignPartner('HHP');
          this.cookieValue = this.getCookie('ffm_ebill_fed_cookie');
          this.cookieService.put('ffm_ebill_fed_cookie','null' ,{domain:'.highmark.com'});
          router.navigate(['/ffm']);
          break;
        } else if(this.getCookie('hhp_sp_ebill_cookie') != null) {
          this.application = 'SP';
          this.cookieValue = this.getCookie('hhp_sp_ebill_cookie');
          var cookieValueDecode = decodeURIComponent(this.cookieValue);
          if(cookieValueDecode!== null && cookieValueDecode !== '') {
            var cookieAtob = atob(cookieValueDecode);
            if(cookieAtob.includes('WNY'))
            {
              this.assignActivePartner('WNY');
            } else if(cookieAtob.includes('NENY')) {
              this.assignActivePartner('NENY');
            } else {
              this.assignActivePartner('');
            }
          }
          this.assignPartner('HHP');
          this.cookieService.put('hhp_sp_ebill_cookie','null' ,{domain:'.highmark.com'});
          router.navigate(['/SP']);
          break;
        } else if(this.getCookie('nd_sp_ebill_cookie') != null) { 
          this.application = 'SP';
          this.assignPartner('ND');
          this.cookieValue = this.getCookie('nd_sp_ebill_cookie');
          this.cookieService.put('nd_sp_ebill_cookie','null' ,{domain:'.bcbsndportals.com'});
          router.navigate(['/SP']);
          break;
        } else if(this.getCookie('wy_sp_ebill_cookie') != null) { 
          this.application = 'SP';
          this.assignPartner('WY');
          this.cookieValue = this.getCookie('wy_sp_ebill_cookie');
          this.cookieService.put('wy_sp_ebill_cookie','null' ,{domain:'.yourwyoblue.com'});
          router.navigate(['/SP']);
          break;
        } else if(this.getCookie('mn_sp_ebill_cookie') != null) { 
          this.application = 'SP';
          this.assignPartner('MN');
          this.cookieValue = this.getCookie('mn_sp_ebill_cookie');
          this.cookieService.put('mn_sp_ebill_cookie','null' ,{domain:'.bluecrossmnonline.com'});
          router.navigate(['/SP']);
          break;
        }else if(this.getCookie('hhp_hs_ebill_cookie') != null) {
          this.application = 'HS';
          this.assignPartner('HHP');
          this.cookieValue = this.getCookie('hhp_hs_ebill_cookie');
          this.cookieService.put('hhp_hs_ebill_cookie','null' ,{domain:'.highmark.com'});
          router.navigate(['/HealthSherpa']);
          break;
        } else if (this.getCookie('w3ll_ebill_ahnj_cookie') !== null && location.href.includes("w3ll")) {
          this.application = 'W3LL';
          this.assignPartner('AHNJ');
          this.cookieValue = this.getCookie('w3ll_ebill_ahnj_cookie');
          this.cookieService.put('w3ll_ebill_ahnj_cookie','null' ,{domain:'.amerihealth.com'});
          router.navigate(['/w3ll']);
        } else if (this.getCookie('w3ll_ebill_ibc_cookie') !== null && location.href.includes("w3ll")) {
          this.application = 'W3LL';
          this.assignPartner('IBC');
          this.cookieValue = this.getCookie('w3ll_ebill_ibc_cookie');
          this.cookieService.put('w3ll_ebill_ibc_cookie','null' ,{domain:'.ibx.com'});
          router.navigate(['/w3ll']);
        }
        /*else if(location.href.includes("HS")){
            console.log('inside else if HS'+location.href);
          var req = new XMLHttpRequest();
          req.open('GET', location.href, false);
          req.send(null);
          var headers = this.parseHttpHeaders(req.getAllResponseHeaders());
          console.log("headers:"+headers);
            /!*const hsid = headers.get('hsid');
            console.log('hsid:'+hsid);*!/
            const hsid ='A190057AA';
           // this.getHealthSherpaDetails("A190057AA");
            this.http.post<any>(this.sharedService.getURI('hsDetails'), {hsid}).subscribe(data =>{
                console.log("response:"+data.responseString);
                this.application = 'HS';
                this.assignPartner('HHP');
                this.cookieService.put('hhp_hs_ebill_cookie', data.responseString); // To Set Cookie
                this.cookieValue = this.getCookie('hhp_hs_ebill_cookie');
                this.cookieService.remove('hhp_hs_ebill_cookie');
                this.router.navigate(['/HS']);
            });
        }*/

        if (i == 4 && !location.href.includes("ffm") && !location.href.includes("neny") && !location.href.includes("wny")) {
          console.log("Using hardcoded cookie value");
          this.application = 'SBE';
          this.assignPartner('IBC');
          this.cookieService.put('ibc_sbe_ebill_fed_cookie', 'eyJTdHJlZXROYW1lMiI6IiIsIkFzc2lnbmVkUUhQSWRlbnRpZmllciI6IjExMjY5V1kwMDcwMDE5LTAxIiwiU3RyZWV0TmFtZTEiOiI3NSBCbHVlYmlyZCBMbiIsIlBhcnRuZXJBc3NpZ25lZENvbnN1bWVySUQiOiIyNzg2IiwiRmlyc3ROYW1lIjoiRFJQSkhBUFBDIiwiTWlkZGxlTmFtZSI6IiIsIlBheW1lbnRUcmFuc2FjdGlvbklEIjoiMjc4NklEMTAwMDAiLCJDb250YWN0RW1haWxBZGRyZXNzIjoiaGFycnkuZ2lsbGlAbWFpbGNhdGNoLmNvbSIsIkFkZGl0aW9uYWxJbmZvcm1hdGlvbiI6IkhIUEhhcnJ5LEdpbGJlcnQ7Sm9lLFN0ZWZoZW4iLCJBUFRDQW1vdW50IjoiMCIsIlRvdGFsQW1vdW50T3duZWQiOiIwIiwiWmlwQ29kZSI6IjA3NjAxIiwiU3RhdGUiOiJOSiIsIlByb3Bvc2VkQ292ZXJhZ2VFZmZlY3RpdmVEYXRlIjoiMDEvMDEvMjAyMSIsIlByZWZlcnJlZExhbmd1YWdlQ29kZSI6IkVOIiwiUHJlbWl1bUFtb3VudFRvdGFsIjoiMCIsIkNpdHlOYW1lIjoiSmVyc2V5IENpdHkiLCJNYXJrZXRJbmRpY2F0b3IiOiJpbmRpdmlkdWFsIiwiU3Vic2NyaWJlcklkZW50aWZpZXIiOiIxMDAwMDAxNjM3IiwiTGFzdE5hbWUiOiJKRUVQIn0K'); // To Set Cookie
          this.cookieValue = this.getCookie('ibc_sbe_ebill_fed_cookie');
          this.cookieService.remove('ibc_sbe_ebill_fed_cookie');
          /*this.assignPartner('AHNJ');
          this.cookieService.put('ahnj_sbe_ebill_fed_cookie', 'eyJTdHJlZXROYW1lMiI6IiIsIkFzc2lnbmVkUUhQSWRlbnRpZmllciI6IjkxNzYyTkowMDcwMDE0LTAxIiwiU3RyZWV0TmFtZTEiOiI3NSBMaWJlcnR5IEF2ZSIsIlBhcnRuZXJBc3NpZ25lZENvbnN1bWVySUQiOiIyNzg2IiwiRmlyc3ROYW1lIjoiRFJQSkhBUFBDIiwiTWlkZGxlTmFtZSI6IiIsIlBheW1lbnRUcmFuc2FjdGlvbklEIjoiMjc4NklEMTkyMzExMzMyIiwiQ29udGFjdEVtYWlsQWRkcmVzcyI6ImhhcnJ5LmdpbGxpQG1haWxjYXRjaC5jb20iLCJBZGRpdGlvbmFsSW5mb3JtYXRpb24iOiJJQkNIYXJyeSxHaWxiZXJ0O0pvZSxTdGVmaGVuIiwiQVBUQ0Ftb3VudCI6IjIxMi44NSIsIlRvdGFsQW1vdW50T3duZWQiOiIzMjcuMDAiLCJaaXBDb2RlIjoiMTkwMTkiLCJTdGF0ZSI6IlBBIiwiUHJvcG9zZWRDb3ZlcmFnZUVmZmVjdGl2ZURhdGUiOiIwMS8wMS8yMDIxIiwiUHJlZmVycmVkTGFuZ3VhZ2VDb2RlIjoiRU4iLCJQcmVtaXVtQW1vdW50VG90YWwiOiI0MzcuMTUiLCJDaXR5TmFtZSI6IlBoaWxhZGVscGhpYSIsIk1hcmtldEluZGljYXRvciI6ImluZGl2aWR1YWwiLCJTdWJzY3JpYmVySWRlbnRpZmllciI6IjEwMDAwMDE2MzciLCJMYXN0TmFtZSI6IkpFRVAifQ=='); // To Set Cookie
          this.cookieValue = this.getCookie('ahnj_sbe_ebill_fed_cookie');
          this.cookieService.remove('ahnj_sbe_ebill_fed_cookie');
          this.assignPartner('HHP');
          this.cookieService.put('hhp_sbe_ebill_fed_cookie', 'eyJTdHJlZXROYW1lMiI6IiIsIkFzc2lnbmVkUUhQSWRlbnRpZmllciI6IjkxNzYyTkowMDcwMDE0LTAxIiwiU3RyZWV0TmFtZTEiOiI3NSBMaWJlcnR5IEF2ZSIsIlBhcnRuZXJBc3NpZ25lZENvbnN1bWVySUQiOiIyNzg2IiwiRmlyc3ROYW1lIjoiRFJQSkhBUFBDIiwiTWlkZGxlTmFtZSI6IiIsIlBheW1lbnRUcmFuc2FjdGlvbklEIjoiMjc4NklEMTkyMzExMzMyIiwiQ29udGFjdEVtYWlsQWRkcmVzcyI6ImhhcnJ5LmdpbGxpQG1haWxjYXRjaC5jb20iLCJBZGRpdGlvbmFsSW5mb3JtYXRpb24iOiJJQkNIYXJyeSxHaWxiZXJ0O0pvZSxTdGVmaGVuIiwiQVBUQ0Ftb3VudCI6IjIxMi44NSIsIlRvdGFsQW1vdW50T3duZWQiOiIzMjcuMDAiLCJaaXBDb2RlIjoiMTkwMTkiLCJTdGF0ZSI6IlBBIiwiUHJvcG9zZWRDb3ZlcmFnZUVmZmVjdGl2ZURhdGUiOiIwMS8wMS8yMDIxIiwiUHJlZmVycmVkTGFuZ3VhZ2VDb2RlIjoiRU4iLCJQcmVtaXVtQW1vdW50VG90YWwiOiI0MzcuMTUiLCJDaXR5TmFtZSI6IlBoaWxhZGVscGhpYSIsIk1hcmtldEluZGljYXRvciI6ImluZGl2aWR1YWwiLCJTdWJzY3JpYmVySWRlbnRpZmllciI6IjEwMDAwMDE2MzciLCJMYXN0TmFtZSI6IkpFRVAifQ=='); // To Set Cookie
          this.cookieValue = this.getCookie('hhp_sbe_ebill_fed_cookie');
          this.cookieService.remove('hhp_sbe_ebill_fed_cookie');*/
          router.navigate(['/sbe']);
          
          // shown alert message to the user if page loads with out any enrollment poral request 
          //this.modalMsg = "We're Sorry. You are not allowed to access this application directly. Please visit your enrollment portal to know about your enrollment details.";

        }

        if (i == 4 && (location.href.includes("neny") || location.href.includes("wny"))) {
          console.log("Using hardcoded cookie value");
          this.application = 'SBE';
          this.assignPartner('HHP');
          this.cookieService.put('ibc_sbe_ebill_fed_cookie', 'eyJTdHJlZXROYW1lMiI6IiIsIkFzc2lnbmVkUUhQSWRlbnRpZmllciI6IiIsIlN0cmVldE5hbWUxIjoiIiwiUGFydG5lckFzc2lnbmVkQ29uc3VtZXJJRCI6IiIsIkZpcnN0TmFtZSI6IiIsIk1pZGRsZU5hbWUiOiIiLCJQYXltZW50VHJhbnNhY3Rpb25JRCI6IiIsIkNvbnRhY3RFbWFpbEFkZHJlc3MiOiIiLCJBZGRpdGlvbmFsSW5mb3JtYXRpb24iOiJISFAiLCJBUFRDQW1vdW50IjoiMCIsIlRvdGFsQW1vdW50T3duZWQiOiIwIiwiWmlwQ29kZSI6IiIsIlN0YXRlIjoiIiwiUHJvcG9zZWRDb3ZlcmFnZUVmZmVjdGl2ZURhdGUiOiIiLCJQcmVmZXJyZWRMYW5ndWFnZUNvZGUiOiJFTiIsIlByZW1pdW1BbW91bnRUb3RhbCI6IjAiLCJDaXR5TmFtZSI6IiIsIk1hcmtldEluZGljYXRvciI6IiIsIlN1YnNjcmliZXJJZGVudGlmaWVyIjoiIiwiTGFzdE5hbWUiOiIifQ=='); // To Set Cookie
          this.cookieValue = this.getCookie('ibc_sbe_ebill_fed_cookie');
          this.cookieService.remove('ibc_sbe_ebill_fed_cookie');
          if (location.hash === '/neny') {
              router.navigate(['/neny']);
          } else if (location.hash === '/wny') {
              router.navigate(['/wny']);
          }
        }
      }
    }

    // setTimeout(function(){
    //   if(location.href.includes("sbe")) {
    //     if (window.localStorage) {
    //       if(!localStorage.getItem('firstLoad')){
    //         localStorage['firstLoad'] = true;
    //         window.location.reload(true);
    //       } else {
    //         localStorage.removeItem('firstLoad');
    //       }
    //     }
    //   }
    // }, 100);

    // Empty the ffm_ebill_fed_cookie if the partners are yourwyoblue and bcbsndportals after redirection
    // if(this.application === 'FFM' && location.href.includes("partner")) {
    //   if (location.href.includes("partner=wy")) {
    //     this.cookieService.put('ffm_ebill_fed_cookie','null' ,{domain:'.yourwyoblue.com'});
    //   } else if (location.href.includes("partner=nd")) {
    //     this.cookieService.put('ffm_ebill_fed_cookie','null' ,{domain:'.bcbsndportals.com'});
    //   }
    // }

    // assign the cookie from pathparam if the partners are yourwyoblue and bcbsndportals after redirection
    if (this.application != 'SBE' && this.application != 'SP' && this.application != 'HS' && (this.cookieValue === null || this.cookieValue === '')) {
      this.application = 'FFM';
      this.assignPartner('HHP');
      this.ffmPartnerWYND = true;
      this.cookieValue = decodeURIComponent(location.href.slice(location.href.lastIndexOf("=")+1));
    }

    if (this.cookieValue != '') {
      this.decodedCookieValue = atob(this.cookieValue);
      if (this.application != 'SBE' && this.application !== 'FFM' && this.application !== 'SP'
          && this.application !== 'HS' &&  this.application !== 'W3LL') {
        this.decodedCookieObj = JSON.parse(this.decodedCookieValue);
      } else {
        this.sbe_decodedCookieObj = JSON.parse(this.decodedCookieValue);
      }
      translate.setDefaultLang('en');

      if (this.application != 'SBE' && this.application != 'FFM' && this.application !== 'SP'
          && this.application !== 'HS' && this.application !== 'W3LL') {
        // Verify that all required fields are present
        if (this.decodedCookieObj.ApplicationID == null || this.decodedCookieObj.ApplicationID == ''
          || this.decodedCookieObj.FirstName == null || this.decodedCookieObj.FirstName == ''
          || this.decodedCookieObj.LastName == null || this.decodedCookieObj.LastName == ''
          || this.decodedCookieObj.ContactEmailAddress == null || this.decodedCookieObj.ContactEmailAddress == ''
          || this.decodedCookieObj.StreetName1 == null || this.decodedCookieObj.StreetName1 == ''
          || this.decodedCookieObj.State == null || this.decodedCookieObj.State == ''
          || this.decodedCookieObj.CityName == null || this.decodedCookieObj.CityName == ''
          || this.decodedCookieObj.ZipCode == null || this.decodedCookieObj.ZipCode == '') {

          this.modalMsg = "connectivity_error";
          $('#returnToGWCModal').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });

        }
      }

      if (this.application == 'SBE' || this.application === 'FFM' || this.application === 'SP'
          || this.application === 'HS' || this.application === 'W3LL') {
        // setSAML_SBE
        if (this.sbe_decodedCookieObj.PreferredLanguageCode == '' || this.sbe_decodedCookieObj.PreferredLanguageCode == null) {
          this.sbe_decodedCookieObj.PreferredLanguageCode = 'EN';
        }

        //check for mandatory fields

        if (this.sbe_decodedCookieObj.TotalAmountOwned == null || this.sbe_decodedCookieObj.TotalAmountOwned == ''
          || this.sbe_decodedCookieObj.TotalAmountOwned.match(/[a-z]/i) || this.sbe_decodedCookieObj.PaymentTransactionID == null 
          || this.sbe_decodedCookieObj.PaymentTransactionID == '' || this.sbe_decodedCookieObj.AssignedQHPIdentifier == null ||
          this.sbe_decodedCookieObj.AssignedQHPIdentifier == '' || this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate == null
          || this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate == '' || this.sbe_decodedCookieObj.FirstName == null ||
          this.sbe_decodedCookieObj.FirstName == '' || this.sbe_decodedCookieObj.LastName == null ||
          this.sbe_decodedCookieObj.LastName == '' || this.sbe_decodedCookieObj.StreetName1 == null ||
          this.sbe_decodedCookieObj.StreetName1 == '' || this.sbe_decodedCookieObj.CityName == null ||
          this.sbe_decodedCookieObj.CityName == '' || this.sbe_decodedCookieObj.State == null ||
          this.sbe_decodedCookieObj.State == '' || this.sbe_decodedCookieObj.ZipCode == null ||
          this.sbe_decodedCookieObj.ZipCode == '') {
            if( this.sbe_decodedCookieObj.PaymentTransactionID === '' && this.application === "SP"){
              console.log("Exception as Without ssn Member/Agent will be able to send a bill in salesportal");
            }
            else{
            console.log("Invalid inbound data");
            this.gservice.setValueInvalidData(true);}
        }

        //console.log("calling setSAML_SBE");
        if (this.sbe_decodedCookieObj.HHPPACARRIER != null && this.sbe_decodedCookieObj.HHPPACARRIER != '') {
          GlobalsService.setSAML_SBE(this.sbe_decodedCookieObj.StreetName2, this.sbe_decodedCookieObj.AssignedQHPIdentifier, this.sbe_decodedCookieObj.StreetName1,
            this.sbe_decodedCookieObj.PartnerAssignedConsumerID, this.sbe_decodedCookieObj.FirstName, this.sbe_decodedCookieObj.MiddleName, this.sbe_decodedCookieObj.PaymentTransactionID,
            this.sbe_decodedCookieObj.ContactEmailAddress, this.sbe_decodedCookieObj.AdditionalInformation, this.sbe_decodedCookieObj.APTCAmount, this.sbe_decodedCookieObj.TotalAmountOwned,
            this.sbe_decodedCookieObj.ZipCode, this.sbe_decodedCookieObj.State, this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate, this.sbe_decodedCookieObj.PreferredLanguageCode,
            this.sbe_decodedCookieObj.PremiumAmountTotal, this.sbe_decodedCookieObj.CityName, this.sbe_decodedCookieObj.HHPPACARRIER, this.sbe_decodedCookieObj.SubscriberIdentifier,
            this.sbe_decodedCookieObj.LastName, this.partner, this.application,this.sbe_decodedCookieObj.ApplicationId,this.sbe_decodedCookieObj.UserType,this.sbe_decodedCookieObj.AgentID);
        } else if(this.application === "SP"){
          GlobalsService.setSAML_SBE(this.sbe_decodedCookieObj.StreetName2, this.sbe_decodedCookieObj.AssignedQHPIdentifier, this.sbe_decodedCookieObj.StreetName1,
            this.sbe_decodedCookieObj.PartnerAssignedConsumerID, this.sbe_decodedCookieObj.FirstName, this.sbe_decodedCookieObj.MiddleName, this.sbe_decodedCookieObj.PaymentTransactionID,
            this.sbe_decodedCookieObj.ContactEmailAddress, this.sbe_decodedCookieObj.AdditionalInformation, this.sbe_decodedCookieObj.APTCAmount, this.sbe_decodedCookieObj.TotalAmountOwned,
            this.sbe_decodedCookieObj.ZipCode, this.sbe_decodedCookieObj.State, this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate, this.sbe_decodedCookieObj.PreferredLanguageCode,
            this.sbe_decodedCookieObj.PremiumAmountTotal, this.sbe_decodedCookieObj.CityName, this.sbe_decodedCookieObj.MarketIndicator, this.sbe_decodedCookieObj.SubscriberIdentifier,
            this.sbe_decodedCookieObj.LastName, this.sbe_decodedCookieObj.Region, this.application, this.sbe_decodedCookieObj.ApplicationId,this.sbe_decodedCookieObj.UserType,this.sbe_decodedCookieObj.AgentID);
        } else if(this.application === "HS"){
          GlobalsService.setSAML_SBE(this.sbe_decodedCookieObj.StreetName2, this.sbe_decodedCookieObj.AssignedQHPIdentifier, this.sbe_decodedCookieObj.StreetName1,
              this.sbe_decodedCookieObj.PartnerAssignedConsumerID, this.sbe_decodedCookieObj.FirstName, this.sbe_decodedCookieObj.MiddleName, this.sbe_decodedCookieObj.PaymentTransactionID,
              this.sbe_decodedCookieObj.ContactEmailAddress, this.sbe_decodedCookieObj.AdditionalInformation, this.sbe_decodedCookieObj.APTCAmount, this.sbe_decodedCookieObj.TotalAmountOwned,
              this.sbe_decodedCookieObj.ZipCode, this.sbe_decodedCookieObj.State, this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate, this.sbe_decodedCookieObj.PreferredLanguageCode,
              this.sbe_decodedCookieObj.PremiumAmountTotal, this.sbe_decodedCookieObj.CityName, this.sbe_decodedCookieObj.MarketIndicator, this.sbe_decodedCookieObj.SubscriberIdentifier,
              this.sbe_decodedCookieObj.LastName, this.sbe_decodedCookieObj.Region, this.application, this.sbe_decodedCookieObj.ApplicationId,this.sbe_decodedCookieObj.UserType,this.sbe_decodedCookieObj.AgentID);
        } else if(this.application === "W3LL"){
          GlobalsService.setSAML_SBE(this.sbe_decodedCookieObj.StreetName2, this.sbe_decodedCookieObj.AssignedQHPIdentifier, this.sbe_decodedCookieObj.StreetName1,
              this.sbe_decodedCookieObj.PartnerAssignedConsumerID, this.sbe_decodedCookieObj.FirstName, this.sbe_decodedCookieObj.MiddleName, this.sbe_decodedCookieObj.PaymentTransactionID,
              this.sbe_decodedCookieObj.ContactEmailAddress, this.sbe_decodedCookieObj.AdditionalInformation, this.sbe_decodedCookieObj.APTCAmount, this.sbe_decodedCookieObj.TotalAmountOwned,
              this.sbe_decodedCookieObj.ZipCode, this.sbe_decodedCookieObj.State, this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate,this.sbe_decodedCookieObj.Language,
              this.sbe_decodedCookieObj.PremiumAmountTotal, this.sbe_decodedCookieObj.CityName, this.sbe_decodedCookieObj.MarketIndicator, this.sbe_decodedCookieObj.SubscriberIdentifier,
              this.sbe_decodedCookieObj.LastName, this.sbe_decodedCookieObj.Region, this.application,'',this.sbe_decodedCookieObj.UserType,this.sbe_decodedCookieObj.AgentID, 
              this.sbe_decodedCookieObj.SuffixName, this.sbe_decodedCookieObj.ProductLineName, this.sbe_decodedCookieObj.PlanName, this.sbe_decodedCookieObj.AdditionalProperties, this.sbe_decodedCookieObj.TINIdentification, 
              this.sbe_decodedCookieObj.Dob, this.sbe_decodedCookieObj.Issuer, this.sbe_decodedCookieObj.ApplicationID);
        } else {
          GlobalsService.setSAML_SBE(this.sbe_decodedCookieObj.StreetName2, this.sbe_decodedCookieObj.AssignedQHPIdentifier, this.sbe_decodedCookieObj.StreetName1,
            this.sbe_decodedCookieObj.PartnerAssignedConsumerID, this.sbe_decodedCookieObj.FirstName, this.sbe_decodedCookieObj.MiddleName, this.sbe_decodedCookieObj.PaymentTransactionID,
            this.sbe_decodedCookieObj.ContactEmailAddress, this.sbe_decodedCookieObj.AdditionalInformation, this.sbe_decodedCookieObj.APTCAmount, this.sbe_decodedCookieObj.TotalAmountOwned,
            this.sbe_decodedCookieObj.ZipCode, this.sbe_decodedCookieObj.State, this.sbe_decodedCookieObj.ProposedCoverageEffectiveDate, this.sbe_decodedCookieObj.PreferredLanguageCode,
            this.sbe_decodedCookieObj.PremiumAmountTotal, this.sbe_decodedCookieObj.CityName, this.sbe_decodedCookieObj.MarketIndicator, this.sbe_decodedCookieObj.SubscriberIdentifier,
            this.sbe_decodedCookieObj.LastName, this.partner, this.application, this.sbe_decodedCookieObj.ApplicationId,this.sbe_decodedCookieObj.UserType,this.sbe_decodedCookieObj.AgentID);
        }

        // check if existing_session_cookie exists
        if (this.cookieService.get('existing_session_cookie')) {
          console.log('Using existing_session_cookie information');
          //if yes, check if existing_session_cookie.SBE_ID == ibc_sbe_ebill_fed_cookie.SBE_ID
          var existingSessionCookieValue = atob(this.cookieService.get('existing_session_cookie'));
          this.existing_session_cookie_obj = JSON.parse(existingSessionCookieValue);
          //console.log(this.existing_session_cookie_obj.SBE_ID + " ,,,, " + GlobalsService.sbe_saml.ConsumerReferenceID);
          if (this.existing_session_cookie_obj.SBE_ID == GlobalsService.sbe_saml.ConsumerReferenceID) {
            // If they match - do not call saml
            this.sbe_call_saml = false;
            console.log("Will not call saml service - duplicate entry");
            //use existing_session_cookie.ApplicationID/existing_session_cookie.SBE_ID
            GlobalsService.SBE_ApplicationID = this.existing_session_cookie_obj.ApplicationID;
            GlobalsService.SBE_ConsumerReferenceID = this.existing_session_cookie_obj.SBE_ID;
            GlobalsService.SBE_Platform = this.existing_session_cookie_obj.Platform;
            GlobalsService.SBE_Region = this.existing_session_cookie_obj.Region;
          } else {
            //if no match, allow normal flow - call saml,
            //use samlResponse.ApplicationID
            this.sbe_call_saml = true;
          }
          if (this.existing_session_cookie_obj.LastPaymentAmount != null &&
            this.existing_session_cookie_obj.LastPaymentDate != null &&
            this.existing_session_cookie_obj.LastProposedCoverageEffectDate != null) {
            GlobalsService.SBE_RecentPayment = true;
            GlobalsService.SBE_LastPaymentDate = this.existing_session_cookie_obj.LastPaymentDate;
            GlobalsService.SBE_LastPaymentAmount = this.existing_session_cookie_obj.LastPaymentAmount;
            GlobalsService.SBE_LastProposedCoverageEffectDate = this.existing_session_cookie_obj.LastProposedCoverageEffectDate;

            this.gservice.setValue(true);
          }
        } else {
          //if no, call /saml
          this.sbe_call_saml = true;
        }
      } else {
        if (this.decodedCookieObj.Language == '' || this.decodedCookieObj.Language == null) {
          this.decodedCookieObj.Language = 'EN';
        }
        GlobalsService.setSAML(this.decodedCookieObj.Language, this.decodedCookieObj.ApplicationID, this.decodedCookieObj.ConsumerReferenceID, this.decodedCookieObj.MarketIndicator, this.decodedCookieObj.SalesChannel, this.decodedCookieObj.ProposedCoverageEffectiveDate, this.decodedCookieObj.AssignedQHPIdentifier,
          this.decodedCookieObj.FirstName, this.decodedCookieObj.MiddleName, this.decodedCookieObj.LastName, this.decodedCookieObj.SuffixName, this.decodedCookieObj.StreetName1, this.decodedCookieObj.StreetName2, this.decodedCookieObj.State, this.decodedCookieObj.CityName, this.decodedCookieObj.ZipCode, this.decodedCookieObj.ContactEmailAddress,
          this.decodedCookieObj.AdditionalInformation, this.decodedCookieObj.ProductLineName, this.decodedCookieObj.productLineCode, this.decodedCookieObj.PlanID, this.decodedCookieObj.AgentID, this.decodedCookieObj.Segment, this.decodedCookieObj.UserType, this.decodedCookieObj.TenantID, this.decodedCookieObj.PlanName,
          this.decodedCookieObj.SuppressCreditCard, this.decodedCookieObj.PremiumAmountTotal, this.decodedCookieObj.PaymentAmount, this.decodedCookieObj.AuthToken, this.decodedCookieObj.ReturnURL, this.decodedCookieObj.PaymentTransactionID, this.decodedCookieObj.UniqueBinderCode);
      }

    } else {
      //COMMENT THIS BLOCK WHEN DYNAMIC COOKIE GEN IS WORKING
      /*
      console.log("Using hardcoded cookie value");

      this.cookieService.put( 'ibc_gwc_ebill_fed_cookie', 'ewogICAgIkxhbmd1YWdlIjoiRU4iLAogICAgIkFwcGxpY2F0aW9uSUQiOiJJQkEtMTA5Mjg4MDk3OSIsCiAgICAiQ29uc3VtZXJSZWZlcmVuY2VJRCI6IjEwNTgyMjk5IiwKICAgICJNYXJrZXRJbmRpY2F0b3IiOiJJTkRJVklEVUFMIiwKICAgICJTYWxlc0NoYW5uZWwiOiJTYWxlc0Nvbm5lY3QiLAogICAgIlByb3Bvc2VkQ292ZXJhZ2VFZmZlY3RpdmVEYXRlIjoiMDYvMDEvMjAyMCIsCiAgICAiQXNzaWduZWRRSFBJZGVudGlmaWVyIjoiMzEyNzRXVjA0OTAwMDEtMDEiLAogICAgIkZpcnN0TmFtZSI6InB1aiIsCiAgICAiTWlkZGxlTmFtZSI6IiIsCiAgICAiTGFzdE5hbWUiOiJyYXkiLAogICAgIlN1ZmZpeE5hbWUiOiIiLAogICAgIlN0cmVldE5hbWUxIjoiMTIzIE1hcGxlIFN0IiwKICAgICJTdHJlZXROYW1lMiI6IiIsCiAgICAiU3RhdGUiOiJQQSIsCiAgICAiQ2l0eU5hbWUiOiJQaXR0c2J1cmdoIiwKICAgICJaaXBDb2RlIjoiMTgwMzkiLAogICAgIkNvbnRhY3RFbWFpbEFkZHJlc3MiOiJwdWppdGhhLnJheWFAZ3VpZGV3ZWxsY29ubmVjdC5jb20iLAogICAgIkFkZGl0aW9uYWxJbmZvcm1hdGlvbiI6InB1aiwgcmF5IiwKICAgICJQcm9kdWN0bGluZW5hbWUiOiJIRUFMVEgiLAogICAgInByb2R1Y3RsaW5lY29kZSI6IjgiLAogICAgIlBsYW5JRCI6IjMzODcxUEEwMTIwMDAzLTAwIiwKICAgICJBZ2VudElEIjoiWjExMy1aMTEzIiwKICAgICJTZWdtZW50IjoiVTY1IiwKICAgICJVc2VyVHlwZSI6IkFnZW50IiwKICAgICJUZW5hbnRJRCI6IkdXQ0lCQ1BBIiwKICAgICJQbGFuTmFtZSI6IktleXN0b25lIEhNTyBTaWx2ZXIiLAogICAgIlN1cHByZXNzQ3JlZGl0Q2FyZCI6Ik4iLAogICAgIlByZW1pdW1BbW91bnRUb3RhbCI6IjIyMi45OSIsCiAgICAiVG90YWxBbW91bnRPd2VkIjoiMjIyLjk5IiwKICAgICJBdXRoVG9rZW4iOiJUZXN0IiwKICAgICJSZXR1cm5VUkwiOiJodHRwczovL2FnZW50LXRlbGVzYWxlcy53ZWJzYWxlcy5xYS5pYnguY29tL2lzcy9zZXJ2aWNlL3BheW1lbnRzL3Bvc3RSZXNwb25zZSIsCiAgICAiUGF5bWVudFRyYW5zYWN0aW9uSUQiOiIiLAogICAgIlVuaXF1ZUJpbmRlckNvZGUiOiIiCn0=' ); // To Set Cookie
      this.assignPartner('IBC');
      this.cookieValue = this.getCookie('ibc_gwc_ebill_fed_cookie');
      this.decodedCookieValue = atob(this.cookieValue);
      this.decodedCookieObj = JSON.parse(this.decodedCookieValue);
      translate.setDefaultLang('en')
      
      GlobalsService.setSAML(this.decodedCookieObj.Language, this.decodedCookieObj.ApplicationID, this.decodedCookieObj.ConsumerReferenceID, this.decodedCookieObj.MarketIndicator, this.decodedCookieObj.SalesChannel, this.decodedCookieObj.ProposedCoverageEffectiveDate, this.decodedCookieObj.AssignedQHPIdentifier,
      this.decodedCookieObj.FirstName, this.decodedCookieObj.MiddleName, this.decodedCookieObj.LastName, this.decodedCookieObj.SuffixName, this.decodedCookieObj.StreetName1, this.decodedCookieObj.StreetName2, this.decodedCookieObj.State, this.decodedCookieObj.CityName, this.decodedCookieObj.ZipCode, this.decodedCookieObj.ContactEmailAddress,
      this.decodedCookieObj.AdditionalInformation, this.decodedCookieObj.Productlinename, this.decodedCookieObj.productlinecode, this.decodedCookieObj.PlanID, this.decodedCookieObj.AgentID, this.decodedCookieObj.Segment, this.decodedCookieObj.UserType, this.decodedCookieObj.TenantID, this.decodedCookieObj.PlanName,
      this.decodedCookieObj.SuppressCreditCard, this.decodedCookieObj.PremiumAmountTotal, this.decodedCookieObj.TotalAmountOwed, this.decodedCookieObj.AuthToken, this.decodedCookieObj.ReturnURL, this.decodedCookieObj.PaymentTransactionID, this.decodedCookieObj.UniqueBinderCode);
      */
      //COMMENT THIS BLOCK WHEN DYNAMIC COOKIE GEN IS WORKING

      //UNCOMMENT THIS BLOCK WHEN DYNAMIC COOKIE GEN IS WORKING

      //this.router.navigateByUrl('/sessionError');

      //UNCOMMENT THIS BLOCK WHEN DYNAMIC COOKIE GEN IS WORKING
    }
  }

  ngOnInit() {
    if (this.application != 'SBE' && this.application != 'FFM' && this.application != 'SP'
        && this.application != 'HS' && this.application != 'W3LL') {
      this.saml = GlobalsService.saml;
    } else {
      this.sbe_saml = GlobalsService.sbe_saml;
    }
    this.assignLanguage();
    if (this.application != 'SBE' && this.application != 'FFM' && this.application != 'SP'
        && this.application != 'HS' && this.application !== 'W3LL') {
      this.postSAMLData();
    }
    if (this.application == 'SBE' && this.sbe_call_saml == true && location.hash != '#/neny' && location.hash != '#/wny') {
      //console.log("calling post data sbe");
      this.postSAMLData_SBE();
      //get pcp indicator
     // this.getPCPIndicator_SBE();
    }

    if (this.application == 'FFM' || this.application === 'W3LL') {
      //console.log("calling post data FFM");
      this.postSAMLData_SBE();
    }

    if (this.application == 'SP' || this.application =='HS') {
      //console.log("calling post data FFM");
      this.postSAMLData_SBE();
    }

    if ((this.application == 'SBE' || this.application == 'FFM' || this.application == 'SP'
        || this.application == 'HS') && location.hash != '#/neny' && location.hash != '#/wny') {
      var source = interval(500);

      var ping = source.subscribe(() => {
        this.http.post<any>(this.sharedService.getURI('saml'), { observe: 'response' })
          .pipe(first())
          .subscribe(resp => {
            if (resp.status === 200) {
              //console.log(true)
            } else {
              //console.log(false)
            }
          }, (err => {
            if (err.status >= 500) {
              ping.unsubscribe();
              this.modalMsg = "connectivity_error_sbe";
              $('#SBEConnErrModal').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
              });
            } else {
              ping.unsubscribe();
            }
          }));
      });
    }

    if (location.hash != '#/neny' && location.hash != '#/wny') {
    //console.log(this.simulationParam, ' - ', this.application == 'SBE' , ' - ' , this.sbe_call_saml);
    this.deleteCookie();
    }
  }

  parseHttpHeaders(httpHeaders) {
    return httpHeaders.split("\n")
        .map(x=>x.split(/: */,2))
        .filter(x=>x[0])
        .reduce((ac, x)=>{ac[x[0]] = x[1];return ac;}, {});
  }

  getHealthSherpaDetails(hsid){
    this.http.post<any>(this.sharedService.getURI('hsDetails'), {hsid}).subscribe(data =>{
      console.log("response:"+data.responseString);
      this.application = 'HS';
      this.assignPartner('HHP');
      this.cookieService.put('hhp_hs_ebill_cookie', data.responseString); // To Set Cookie
      this.cookieValue = this.getCookie('hhp_hs_ebill_cookie');
      this.cookieService.remove('hhp_hs_ebill_cookie');
      this.router.navigate(['/HS']);
    });

  }
  postSAMLData() {
    //Call backend service passing json payload (this service saves incoming saml to db)
    this.http.post<any>(this.sharedService.getURI('saml'), JSON.stringify(this.saml)).subscribe(data => {
      GlobalsService.businessName = data.businessName;
      if (data.responseString === 'DUPLICATE') {
        window.location.href = data.returnURL;
        // check if post request response is duplicate
        // If status code is 200 but shows duplicate ApplicationID in SAML, show 'returnToGWCModal'
        // Uncomment the commented code below to show this error popup onInit
        //TODO-7/6 - in this case, immediately redirect to returnURL (once it is being returned from saml service)
        /*
        this.modalMsg = "payment_made";
        $('#returnToGWCModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
        */
      } else if (data.responseString === 'SAML SERVICES FAILED') {
        window.location.href = data.returnURL;
      } else if (data.result === false) {
        this.modalMsg = "connectivity_error";
        $('#returnToGWCModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      }
    },
      (error => {
        this.modalMsg = "connectivity_error_eblarcDOWN";
        $('#returnToGWCModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      }));
  }


  postSAMLData_SBE() {
    //Call backend service passing json payload (this service saves incoming saml to db)
    this.http.post<any>(this.sharedService.getURI('saml'), JSON.stringify(this.sbe_saml)).subscribe(data => {
      // Added redirection for FFM if the redirect url has yourwyoblue and bcbsndportals partners
      if(this.application === 'FFM' && data.redirectURL && !this.ffmPartnerWYND) {
        if(data.redirectURL.includes("yourwyoblue.com")) {
          window.location.href= data.redirectURL + '#/ffm?partner=wy&refid=' + this.cookieValue;
          //window.location.href= 'http://localhost:4200/' + '#/ffm?partner=wy&refid=' + this.cookieValue; //this is for local
        } else if (data.redirectURL.includes("bcbsndportals.com")) {
          this.cookieService.put('temp_ffm_ebill_fed_cookie',this.cookieValue ,{domain:'.bcbsndportals.com'});
          this.cookieService.remove('temp_ffm_ebill_fed_cookie');
          window.location.href= data.redirectURL + '#/ffm?partner=nd&refid=' + this.cookieValue;
          //window.location.href= 'http://localhost:4200/' + '#/ffm?partner=nd&refid=' + this.cookieValue; //this is for local
        }
      }
      if (data.result === false) {
        this.modalMsg = "connectivity_error_sbe";
        $('#SBEConnErrModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      } else if (data.result === true) {
        GlobalsService.SBE_ApplicationID = data.applicationId;
        GlobalsService.SBE_ConsumerReferenceID = this.sbe_saml.ConsumerReferenceID;        
        GlobalsService.SBE_Platform = this.application;
        GlobalsService.businessName = data.businessName;
        if(this.application === "SP" || this.application === "HS"){
          GlobalsService.SBE_Region = this.sbe_saml.Region;
        }
        else{
          GlobalsService.SBE_Region = this.partner;
        }
        //setting PCP indicator and URL
        if (this.application == 'SBE'){
          console.log("inside SBE to set indicator"+ data.pcpIndicator +"-URL-"+data.pcpURL);
          if(data.pcpIndicator === 'Y'){
            console.log("inside SBE if to set indicator");
            GlobalsService.pcpIndicator = true;
            GlobalsService.pcpURL = data.pcpURL;
          } else{
            console.log("inside SBE else to set indicator");
            GlobalsService.pcpIndicator = false;
          } 
        }
         console.log("outside SBE to set indicator");
       // console.log(GlobalsService.pcpIndicator);
        var o: existing_session_cookie_object = { "ApplicationID": null, "SBE_ID": null, "Platform": null, "Region": null, "LastPaymentDate": null, "LastPaymentAmount": null, "LastProposedCoverageEffectDate": null };
        o.ApplicationID = GlobalsService.SBE_ApplicationID;
        o.SBE_ID = GlobalsService.SBE_ConsumerReferenceID;
        o.Region = GlobalsService.SBE_Region;
        o.Platform = GlobalsService.SBE_Platform;
        o.LastPaymentDate = data.lastPaymentDate;
        o.LastPaymentAmount = data.lastPaymentAmount;
        o.LastProposedCoverageEffectDate = data.lastProposedCoverageEffectDate;
        var escValue = btoa(JSON.stringify(o));
        this.cookieService.put('existing_session_cookie', escValue);
        //console.log(escValue);

        if (data.lastPaymentDate == null && data.lastPaymentAmount == null && data.lastProposedCoverageEffectDate == null) {
          console.log("A payment was not made in the past 15 days");
        } else {
          console.log("A payment was made in the past 15 days");
          GlobalsService.SBE_RecentPayment = true;
          GlobalsService.SBE_LastPaymentDate = data.lastPaymentDate;
          GlobalsService.SBE_LastPaymentAmount = data.lastPaymentAmount;
          GlobalsService.SBE_LastProposedCoverageEffectDate = data.lastProposedCoverageEffectDate;

          this.gservice.setValue(true);
          let tempBalance: number = +this.sbe_saml.TotalAmountOwed;
          if (GlobalsService.SBE_RecentPayment && tempBalance > 0) {
          if (GlobalsService.partner == 'HHP') {
            $('#SBERecentPaymentModal').modal({
              backdrop: 'static',
              keyboard: false,
              show: true
            });
          } else {
            $('#SBERecentPaymentModalIBC').modal({
              backdrop: 'static',
              keyboard: false,
              show: true
            });
          }
        }
          
          // NATALIE TODO show message asking user - are you sure you want to proceed, you made a payment on xx/xx/yyyy ...
          //NATALIE TODO

          //if saml response indicates payment or bill request in past 15 days,
          //show message - "are you sure you want to proceed? you made a payment
          //of $xx.xx on mm/dd/yyyy"

          //if user proceeds, follow normal flow

          //if user cancels, show "all done" page

          //if saml response indicates NO payment or bill requests in past 15 days,
          //follow normal flow
        }
      }
    },
      (error => {
        if (this.application == 'FFM') {
          $('#SBERecentPaymentModal').modal('hide');
        } else if (this.application == 'SP' || this.application == 'HS') {
          $('#SBERecentPaymentModal').modal('hide');
        }
        this.modalMsg = "connectivity_error_sbe";
        $('#SBEConnErrModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      }));
  }

  assignPartner(partnerID: string) {
    GlobalsService.partner = partnerID;
  }

  assignActivePartner(activePartnerID: string) {
    GlobalsService.activePartner = activePartnerID;
  }

  assignLanguage() {
    if (GlobalsService.language.toLowerCase() == 'es') {
      this.translate.use('es');
    } else {
      this.translate.use('en');
    }
  }

  // Delete the cookie after reading the cookie values
  deleteCookie() {
    var getDeleteCookieURI;
    if(location.href.includes('shoptenv')) {
      var myWindow = window.open('https://cdssotest.highmark.com/hmkauth/epay/sbeffmlogout', "myWindow", "width=200,height=100");
    } else if(location.href.includes('shop')) {
      var myWindow = window.open('https://cdsso.highmark.com/hmkauth/epay/sbeffmlogout', "myWindow", "width=200,height=100");
    } else {
      var myWindow = window.open('https://cdssotest.highmark.com/hmkauth/epay/sbeffmlogout', "myWindow", "width=200,height=100");
    }
    //console.log('getDeleteCookieURI', getDeleteCookieURI);
    // this.http.get<any>(this.sharedService.getURI(getDeleteCookieURI)).subscribe(data => {
      
    // },
    //   (error => {
        
    //   }));
    //window.open("getDeleteCookieURI");
    
    
    setTimeout(function(){
      myWindow.close();
          }, 200);
  }

}

export class existing_session_cookie_object {
  ApplicationID: string;
  SBE_ID: string;
  Region: string;
  Platform: string;
  LastPaymentDate: string;
  LastPaymentAmount: string;
  LastProposedCoverageEffectDate: string;
}
